/**
* @file 资源管理-司机资源-创建司机
* */
<template>
  <div id="driverFormBackup">
    <div name="formI">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="22">
          <div class="formTitle">司机基本信息</div>
        </el-col>
        <el-col :span="2" style="text-align:right">
          <el-button type="primary" v-show="!editI" @click="formEdit(true, 'formI', 'editI', 'temporaryFormI')">编辑</el-button>
        </el-col>
      </el-row>

      <div class="blueInfo">
        <p>* 真实姓名、身份证号，可根据上传的身份证(正面)自动识别</p>
        <p>* 当关闭AI识别或余额不足时，自动识别将失效</p>
      </div>

      <el-form :model="formI" ref="formI" :disabled="!editI" label-position="left" label-width="150px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="司机头像" class="custom-form-center">
              <up-img :disabled="!editI" :file.sync="formI.headPortrait" width="80" height="80"></up-img>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2"> </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="身份证(正面)" prop="idCardFrontPath" class="custom-form-center">
              <up-img :disabled="!editI" :file.sync="formI.idCardFrontPath" width="120" height="80"></up-img>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="驾驶证" class="custom-form-center">
              <up-img :disabled="!editI" :file.sync="formI.driverLicensePath" width="120" height="80"></up-img>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="身份证(背面)" prop="idCardBackPath" class="custom-form-center">
              <up-img :disabled="!editI" :file.sync="formI.idCardBackPath" width="120" height="80"></up-img>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="从业资格证" class="custom-form-center" prop="qualificationsPath">
              <up-img :disabled="!editI" :file.sync="formI.qualificationsPath" width="120" height="80"></up-img>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="真实姓名" prop="name">
              <el-input v-model="formI.name" maxlength="12"></el-input><span style="
                    color: #ccc;
                    margin-left: 10px;
                    position: absolute;
                    white-space: nowrap;
                  ">自动识别</span>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="登录密码" prop="password" :required="id ? false : true">
              <el-input v-model="formI.password" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" maxlength="12">
                <i slot="suffix" :class="showPassword ? 'el-icon-view' : 'el-icon-close'" style="cursor:pointer;line-height:32px;margin-right:8px" @click="showPassword = !showPassword"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="formI.idCard" maxlength="18"></el-input>
              <span style="
                    color: #ccc;
                    margin-left: 10px;
                    position: absolute;
                    white-space: nowrap;
                  ">自动识别
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="确认密码" prop="checkPassword" :required="id ? false : true">
              <el-input v-model="formI.checkPassword" :type="showConfirmPassword ? 'text' : 'password'" autocomplete="new-password" maxlength="12">
                <i slot="suffix" :class="showConfirmPassword ? 'el-icon-view' : 'el-icon-close'" style="cursor:pointer;line-height:32px;margin-right:8px" @click="showConfirmPassword = !showConfirmPassword"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="formI.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="机构名称" prop="organizationId">
              <el-select :disabled="id ? true : false" v-model="formI.organizationId" filterable
                v-if="mixinUserInfo && mixinUserInfo.organizationType === 1">
                <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
                </el-option>
              </el-select>
              <span v-else>{{
                organizations && organizations[0] && organizations[0].name
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="开户行" prop="openingBank">
              <el-input v-model="formI.openingBank" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="银行卡号" prop="bankCardNo">
              <el-input v-model="formI.bankCardNo" maxlength="19"
                @input="formI.bankCardNo = formI.bankCardNo.replace(/[^0-9.]/g, '')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right">
          <el-button v-show="editI" type="primary" @click="formSave('formI')" :loading="loadingI">
            保存
          </el-button>

          <el-button v-show="editI" @click="formEdit(false, 'formI', 'editI', 'temporaryFormI')" :loading="loadingI">
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>

    <div name="formII">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="22">
          <div class="formTitle">详细信息</div>
        </el-col>
      </el-row>

      <div class="blueInfo">
        <p>* 如已开通监管对接服务，则信息必填</p>
      </div>

      <el-form :model="formII" ref="formII" :disabled="!editII" label-position="left" label-width="150px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="性别" prop="driverGender">
              <el-radio-group v-model="formII.driverGender" size="mini">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="状态" prop="driverStatus">
              <el-radio-group v-model="formII.driverStatus" size="mini">
                <el-radio label="ZG">在岗</el-radio>
                <el-radio label="LZ">离职</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="民族" prop="nation">
              <el-input v-model="formII.nation" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="外语能力" prop="foreignLanguageLevel">
              <el-input v-model="formII.foreignLanguageLevel" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="学历" prop="driverEducation">
              <el-select v-model="formII.driverEducation" filterable>
                <el-option v-for="(item, i) in $const.DRIVEREDUCATION" :key="i" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="手机型号" prop="mobileModel">
              <el-input v-model="formII.mobileModel" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="婚姻状况" prop="maritalStatus">
              <el-radio-group v-model="formII.maritalStatus" size="mini">
                <el-radio :label="0">未婚</el-radio>
                <el-radio :label="1">已婚</el-radio>
                <el-radio :label="2">保密</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="手机运营商" prop="mobileOperators">
              <el-select v-model="formII.mobileOperators" filterable>
                <el-option v-for="(item, i) in $const.MOBILEOPERATORS" :key="i" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="出生日期" prop="driverBirthday">
              <el-date-picker v-model="formII.driverBirthday" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="紧急联系人姓名" prop="emergency">
              <el-input v-model="formII.emergency" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="机动车驾驶证号" prop="motorNo">
              <el-input v-model="formII.motorNo" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="紧急联系人电话" prop="emergencyPhone">
              <el-input v-model="formII.emergencyPhone" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="驾驶员通信地址" prop="driverContactAddress">
              <el-input v-model="formII.driverContactAddress" maxlength="256" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="紧急联系人地址" prop="emergencyAddress">
              <el-input v-model="formII.emergencyAddress" maxlength="256" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="户口登记机关名称" prop="householdRegistrationName">
              <el-input v-model="formII.householdRegistrationName" maxlength="256" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="户口住址或长住地址" prop="driverAddress">
              <el-input v-model="formII.driverAddress" maxlength="256" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right">
          <el-button v-show="editII" type="primary" @click="formSave('formII')" :loading="loadingII">
            保存
          </el-button>
          <el-button v-show="editII" @click="formEdit(false, 'formII', 'editII', 'temporaryFormII')" :loading="loadingII">
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>

    <div name="formIII">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="22">
          <div class="formTitle">证件信息</div>
        </el-col>
      </el-row>

      <div class="blueInfo">
        <p>* 如已开通监管对接服务，则信息必填</p>
      </div>

      <el-form :model="formIII" ref="formIII" :disabled="!editIII" label-position="left" label-width="210px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="驾照类型" prop="driverType">
              <el-select v-model="formIII.driverType" filterable>
                <el-option v-for="(item, i) in $const.DRIVERTYPE" :key="i" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="网约车从业资格证起始时间" prop="netCarQualificationsStart">
              <el-date-picker v-model="formIII.netCarQualificationsStart" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="驾驶员发证机构" prop="licenseOrganization">
              <el-input v-model="formIII.licenseOrganization" maxlength="128"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="网约车从业资格证到期时间" prop="netCarQualificationsEnd">
              <el-date-picker v-model="formIII.netCarQualificationsEnd" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="驾驶证有效期限起" prop="driveLicenceStart">
              <el-date-picker v-model="formIII.driveLicenceStart" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="驾驶员领证日期" prop="networkTaximanLicenseDate">
              <el-date-picker v-model="formIII.networkTaximanLicenseDate" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="驾驶证有效期限止" prop="driveLicenceEnd">
              <el-date-picker v-model="formIII.driveLicenceEnd" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="网络预约出租汽车驾驶员资格证号" prop="networkTaximanNo">
              <el-input v-model="formIII.networkTaximanNo" maxlength="128"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="初次领取驾驶证日期" prop="licensingTime">
              <el-date-picker v-model="formIII.licensingTime" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="是否巡游出租汽车驾驶员" prop="isCruisingTaxiDriver">
              <el-radio-group v-model="formIII.isCruisingTaxiDriver" size="mini">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right">
          <el-button v-show="editIII" type="primary" @click="formSave('formIII')" :loading="loadingIII">
            保存
          </el-button>
          <el-button v-show="editIII" @click="formEdit(false, 'formIII', 'editIII', 'temporaryFormIII')"
            :loading="loadingIII">
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>

    <div name="formIIII">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="22">
          <div class="formTitle">合同信息</div>
        </el-col>
      </el-row>

      <div class="blueInfo">
        <p>* 如已开通监管对接服务，则信息必填</p>
      </div>

      <el-form :model="formIIII" ref="formIIII" :disabled="!editIIII" label-position="left" label-width="210px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="合同状态" prop="contractStatus">
              <el-radio-group v-model="formIIII.contractStatus" size="mini">
                <el-radio label="YX">有效</el-radio>
                <el-radio label="WX">无效</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="合同审核结果" prop="censorResult">
              <el-radio-group v-model="formIIII.censorResult" size="mini">
                <el-radio label="TG">通过</el-radio>
                <el-radio label="BTG">不通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="合同上传扫描件类型" prop="contractType">
              <el-radio-group v-model="formIIII.contractType" size="mini">
                <el-radio label="TG">合同</el-radio>
                <el-radio label="BTG">协议</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="合同（或协议）有效期起" prop="contractStart">
              <el-date-picker v-model="formIIII.contractStart" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="合同上传扫描件" prop="contractPhoto" class="custom-form-center">
              <up-img :disabled="!editIIII" :file.sync="formIIII.contractPhoto" width="120" height="80"></up-img>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="合同（或协议）有效期止" prop="contractEnd">
              <el-date-picker v-model="formIIII.contractEnd" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right">
          <el-button v-show="editIIII" type="primary" @click="formSave('formIIII')" :loading="loadingIIII">
            保存
          </el-button>
          <el-button v-show="editIIII" @click="
            formEdit(false, 'formIIII', 'editIIII', 'temporaryFormIIII')
          " :loading="loadingIIII">
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>


    <div name="Punishment">
      <!-- 模态框 -->
      <el-dialog :visible.sync="punishmentVisible" @close="$refs.formPunishment.resetFields()" width="26%" title="处罚信息">
        <el-form :model="formPunishment" ref="formPunishment" label-position="left" label-width="120px">
          <el-form-item label="处罚原因" prop="punishReason">
            <el-input type="textarea" v-model="formPunishment.punishReason" maxlength="100">
            </el-input>
          </el-form-item>
          <el-form-item label="处罚结果" prop="punishResult" class="white">
            <el-input type="textarea" v-model="formPunishment.punishResult" maxlength="100">
            </el-input>
          </el-form-item>
          <el-form-item label="处罚时间" prop="punishTime">
            <el-date-picker v-model="formPunishment.punishTime" size="mini" type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="
              text-align: center;
              padding-top: 0;
              position: relative;
              top: -15px;
            ">
          <el-button type="primary" :loading="loadingPunishment" @click="formSave('formPunishment')">
            保存
          </el-button>
        </div>
      </el-dialog>

      <el-row>
        <el-col :span="22">
          <div class="formTitle">处罚信息</div>
        </el-col>
      </el-row>
      <el-table style="margin-bottom: 20px" border empty-text="暂无数据" v-loading="loadingPunishmentRows"
        :data="punishmentRows">
        <el-table-column v-for="(item, index) in punishmentColumns" :key="index" :show-overflow-tooltip="true"
          :prop="item.prop" :label="item.label">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "driverFormBackup",
  props: {
    id: Number
  },
  data() {
    return {
      idCardIF: false,
      // 当前是修改进入页面的话不调用身份验证，重新上传则验证
      flag: true,

      // 培训信息
      trainingColumns: [
        { prop: "organizationName", label: "培训机构名称" },
        { prop: "courseName", label: "培训内容" },
        { prop: "courseDate", label: "培训课程日期" },
        { prop: "startTime", label: "开始时间" },
        { prop: "stopTime", label: "结束时间" },
      ],
      trainingRows: [],
      loadingTraining: false,

      // 基本信息表单
      editI: false,
      temporaryFormI: null,
      formI: {
        name: null,
        phone: null,
        idCard: null,
        password: null,
        checkPassword: null,
        organizationId: null,
        idCardFrontPath: null,
        idCardBackPath: null,
        qualificationsPath: null,
        openingBank: null,
        bankCardNo: null,
      },

      // 详细信息表单
      editII: false,
      temporaryFormII: null,
      formII: {
        driverGender: null,
        driverStatus: null,
        nation: null,
        foreignLanguageLevel: null,
        driverEducation: null,
        mobileModel: null,
        maritalStatus: null,
        mobileOperators: null,
        driverBirthday: null,
        emergency: null,
        motorNo: null,
        emergencyPhone: null,
        driverContactAddress: null,
        emergencyAddress: null,
        householdRegistrationName: null,
        driverAddress: null,
      },

      // 证件信息表单
      editIII: false,
      temporaryFormIII: null,
      formIII: {
        driverType: null,
        netCarQualificationsStart: null,
        licenseOrganization: null,
        netCarQualificationsEnd: null,
        driveLicenceStart: null,
        networkTaximanLicenseDate: null,
        driveLicenceEnd: null,
        networkTaximanNo: null,
        licensingTime: null,
        isCruisingTaxiDriver: null,
      },

      // 合同信息表单
      editIIII: false,
      temporaryFormIIII: null,
      formIIII: {
        contractStatus: null,
        censorResult: null,
        contractPhoto: null,
        contractType: null,
        contractStart: null,
        contractEnd: null,
      },

      // 处罚信息
      punishmentVisible: false,
      formPunishment: {
        punishmentMoney: undefined,
      },
      rulesPunishment: {
        punishReason: [{ required: true, message: "请输入处罚原因" }],
        punishResult: [{ required: true, message: "请输入处罚结果" }],
        punishTime: [{ required: true, message: "请选择处罚时间" }],
      },
      punishmentColumns: [
        { prop: "punishReason", label: "处罚原因" },
        { prop: "punishResult", label: "处罚结果" },
        { prop: "punishTime", label: "处罚时间" },
      ],
      punishmentRows: [],

      showPassword: false,
      showConfirmPassword: false,
      // 保存按钮loading
      loadingI: false,
      loadingII: false,
      loadingIII: false,
      loadingIIII: false,
      loadingPunishment: false,
      loadingPunishmentRows: false,
    };
  },

  watch: {
    id(val) {
      this.driverInfo();
    },
    'formI.idCardFrontPath': function(val, oldVal) {
      this.ocrIdCard(val, oldVal);
    }
  },

  async created() {
    this.driverInfo();
  },

  methods: {
    // type:编辑或者取消 formName:表单form editNumber:编辑下标 temporaryForm:临时form对象
    formEdit(type, formName, editNumber, temporaryForm) {
      if (editNumber != "editI" && !this.id) {
        this.$message.warning("请先完善【基本信息】并保存后，再进行操作");
        return;
      }
      if (type) {
        this[temporaryForm] = JSON.parse(JSON.stringify(this[formName]));
        this[editNumber] = true;
      } else {
        this.$refs[formName].resetFields();
        this[formName] = JSON.parse(JSON.stringify(this[temporaryForm]));
        this[editNumber] = false;
      }
    },
    edit(row) {
      this.punishmentVisible = true;
      this.$nextTick(() => {
        this.formPunishment = JSON.parse(JSON.stringify(row));
      });
    },
    // 添加处罚信息事件
    punishmentAdd() {
      if (!this.id) {
        this.$message.warning("请先完善【基本信息】并保存后，再进行操作");
      } else {
        this.punishmentVisible = true;
      }
    },
    //删除处罚信息
    async removePunishment(row) {
      let insuranceURL = "/api/v1/manage/driver/supervise/punishment/" + row.id;
      let res = await this.$axios.delete(insuranceURL);
      if (res && res.code === 1) {
        this.$message.success("已删除");
        this.getPunishmentRows();
      }
    },
    /**
     * 点击保存
     */
    async formSave(formName) {
      let formIValidate = false;
      this.$refs.formI.validate((valid) => {
        if (valid) {
          formIValidate = true;
        }
      });
      switch (formName) {
        case "formI":
          if (formIValidate) {
            if (this.id) {
              this.putFn();
            } else {
              this.postFn();
            }
          } else {
            this.$message.warning("请检查表单数据是否输入正确！");
          }
          break;
        case "formII":
          this.$refs.formII.validate((valid) => {
            if (valid) {
              this.postSupervise();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "formIII":
          this.$refs.formIII.validate((valid) => {
            if (valid) {
              this.postIdentity();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "formIIII":
          this.$refs.formIIII.validate((valid) => {
            if (valid) {
              this.postContract();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "formPunishment":
          this.$refs.formPunishment.validate((valid) => {
            if (valid) {
              this.postPunishment();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        default:
          break;
      }
    },
    // 基本信息新增
    async postFn() {
      this.loading = true;
      let url = "/api/v1/manage/driver";
      let params = this.$utils.deepCopyFn(this.formI);
      params.password = params.password
        ? this.$utils.sha256Fn(params.password)
        : "";
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.id = data.data;
        this.editI = false;
      }
      this.loading = false;
    },
    // 基本信息编辑
    async putFn() {
      this.loading = true;
      let url = "/api/v1/manage/driver";
      let params = this.$utils.deepCopyFn(this.formI);
      if (params.password) {
        params.password = this.$utils.sha256Fn(params.password);
      }
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.editI = false;
      }
      this.loading = false;
    },

    // 详细信息操作
    async postSupervise() {
      this.loadingII = true;
      let url = "/api/v1/manage/driver/supervise/info";
      let params = this.$utils.deepCopyFn({
        ...this.formII,
        driverBirthday: Date.parse(new Date(this.formII.driverBirthday)),
        driverId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.editII = false;
      }
      this.loadingII = false;
    },

    // 证件信息操作
    async postIdentity() {
      this.loadingIII = true;
      let url = "/api/v1/manage/driver/supervise/identity/info";
      let params = this.$utils.deepCopyFn({
        ...this.formIII,
        netCarQualificationsStart: Date.parse(
          new Date(this.formIII.netCarQualificationsStart)
        ),
        netCarQualificationsEnd: Date.parse(
          new Date(this.formIII.netCarQualificationsEnd)
        ),
        driveLicenceStart: Date.parse(new Date(this.formIII.driveLicenceStart)),
        driveLicenceEnd: Date.parse(new Date(this.formIII.driveLicenceEnd)),
        networkTaximanLicenseDate: Date.parse(
          new Date(this.formIII.networkTaximanLicenseDate)
        ),
        licensingTime: Date.parse(new Date(this.formIII.licensingTime)),
        driverId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.editIII = false;
      }
      this.loadingIII = false;
    },

    // 合同信息操作
    async postContract() {
      this.loadingIIII = true;
      let url = "/api/v1/manage/driver/supervise/contract/info";
      let params = this.$utils.deepCopyFn({
        ...this.formIIII,
        contractStart: Date.parse(new Date(this.formIIII.contractStart)),
        contractEnd: Date.parse(new Date(this.formIIII.contractEnd)),
        driverId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.editIIII = false;
      }
      this.loadingIIII = false;
    },

    /**
     * 处罚信息操作
     */
    async postPunishment() {
      this.loadingPunishment = true;
      let url = "/api/v1/manage/driver/supervise/punishment";
      let params = this.$utils.deepCopyFn({
        ...this.formPunishment,
        punishTime: Date.parse(new Date(this.formPunishment.punishTime)),
        driverId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.punishmentVisible = false;
        this.getPunishmentRows();
      }
      this.loadingPunishment = false;
    },

    // 获取单个司机详情
    async driverInfo() {
      if (!this.id) {
        return false;
      } else {
        this.flag = false;
      }

      let url = "/api/v1/manage/backups/driver/" + this.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.formI = data.data || {};
      }

      let formIIURL = "/api/v1/manage/driver/supervise/info/" + this.id;
      let dataII = await this.$axios.get(formIIURL);
      if (dataII && dataII.code === 1) {
        this.formII = dataII.data || {};
      }

      let formIIIURL =
        "/api/v1/manage/driver/supervise/identity/info/" + this.id;
      let dataIII = await this.$axios.get(formIIIURL);
      if (dataIII && dataIII.code === 1) {
        this.formIII = dataIII.data || {};
      }

      let formIIIIURL =
        "/api/v1/manage/driver/supervise/contract/info/" + this.id;
      let dataIIII = await this.$axios.get(formIIIIURL);
      if (dataIIII && dataIIII.code === 1) {
        this.formIIII = dataIIII.data || {};
      }
      this.getTrainingRows();
      this.getPunishmentRows();
    },
    async view(row) {
      this.$utils.largeImgFn(row.photo)
    },
    //获取培训计划列表
    async getTrainingRows() {
      this.loadingTraining = true;
      let trainingURL = "/api/v1/manage/driver/supervise/train";
      let params = {
        driverId: this.id,
      };
      let res = await this.$axios.get(trainingURL, params);
      if (res && res.code === 1) {
        res.data.forEach((item) => {
          item.courseDate = this.$utils.timeFn(item.courseDate, "YYYY/MM/DD");
          item.startTime = this.$utils.timeFn(
            item.startTime,
            "YYYY/MM/DD HH:mm:SS"
          );
          item.stopTime = this.$utils.timeFn(
            item.stopTime,
            "YYYY/MM/DD HH:mm:SS"
          );
          item.startTime = item.startTime.substring(11, 16);
          item.stopTime = item.stopTime.substring(11, 16);
        });
        this.trainingRows = res.data || [];
      }
      this.loadingTraining = false;
    },
    //获取处罚信息列表
    async getPunishmentRows() {
      this.loadingPunishmentRows = true;
      let punishmentURL =
        "/api/v1/manage/driver/supervise/punishment/" + this.id;
      let res = await this.$axios.get(punishmentURL);
      if (res && res.code === 1) {
        res.data.forEach((item) => {
          item.punishTime = this.$utils.timeFn(
            item.punishTime,
            "YYYY/MM/DD HH:mm:SS"
          );
        });
        this.punishmentRows = res.data || [];
      }
      this.loadingPunishmentRows = false;
    },
    async ocrIdCard(val, oldVal) {
      if (this.editI && val && oldVal === '') {
        let url = '/api/v1/manage/driver/ocr/idCard';
        let params = { idCardImage: val };
        let data = await this.$axios.post(url, params);
        if (data && data.code == 1) {
          this.formI.idCard = data.data.idCard;
          this.formI.name = data.data.name;
          this.$message.success('身份证识别成功');
        }
      }
    },
  },
};
</script>

<style lang="less">
#driverFormBackup {
  width: 1100px;
  padding-left: 40px;

  .el-dialog__header {
    padding-left: 40px;
  }

  .el-dialog__body {
    padding: 0 40px 20px 40px;
  }

  .first-level {
    display: block;
  }

  .second-level {
    padding-left: 24px;
  }

  .Identity-upload {
    display: flex;
    flex-wrap: wrap;
    width: 600px;
    margin-top: 30px;
  }

  .el-form-item__label {
    text-align: left;
  }

  .attention {
    background-color: #f2f2f2;
    width: 650px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding-left: 10px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
}</style>
